const oktaEnvSignInConfig = {
  local: {
    baseUrl: 'http://localhost:3000',
    redirectUri: 'http://localhost:3000',
    clientId: '0oac6fquljDV6iiYY0h7',
    authParams: {
      issuer: 'https://cfahome.oktapreview.com/oauth2/ausc6e4sj2fnPnQ670h7',
      pkce: false,
    },
  },
  development: {
    baseUrl: 'https://host.dev-ctrl.cfahome.com',
    redirectUri: 'https://host.dev-ctrl.cfahome.com',
    clientId: '0oac6fquljDV6iiYY0h7',
    authParams: {
      issuer: 'https://cfahome.oktapreview.com/oauth2/ausc6e4sj2fnPnQ670h7',
      pkce: false,
    },
  },
  test: {
    baseUrl: 'https://host.test-ctrl.cfahome.com',
    redirectUri: 'https://host.test-ctrl.cfahome.com',
    clientId: '0oac8yb7vhKbKhN510h7',
    authParams: {
      issuer: 'https://cfahome.oktapreview.com/oauth2/auscjsakz3PaAP82K0h7',
      pkce: false,
    },
  },
  beta: {
    baseUrl: 'https://host.beta.ctrl.cfahome.com',
    redirectUri: 'https://host.beta.ctrl.cfahome.com',
    clientId: '0oa56wex25aYVEJLb1t7',
    authParams: {
      issuer: 'https://cfahome.okta.com/oauth2/aus4i6zex3F52d4rn1t7',
      pkce: false,
    },
  },
  production: {
    baseUrl: 'https://host.ctrl.cfahome.com',
    redirectUri: 'https://host.ctrl.cfahome.com',
    clientId: '0oa56wex25aYVEJLb1t7',
    authParams: {
      issuer: 'https://cfahome.okta.com/oauth2/aus4i6zex3F52d4rn1t7',
      pkce: false,
    },
  },
};
const oktaEnvAuthConfig = {
  local: {
    issuer: 'https://cfahome.oktapreview.com/oauth2/ausc6e4sj2fnPnQ670h7',
    redirectUri: 'http://localhost:3000',
    clientId: '0oac6fquljDV6iiYY0h7',
    pkce: false,
  },
  development: {
    redirectUri: 'http://localhost:3000',
    clientId: '0oac6fquljDV6iiYY0h7',
    issuer: 'https://cfahome.oktapreview.com/oauth2/ausc6e4sj2fnPnQ670h7',
    pkce: false,
  },
  test: {
    redirectUri: 'https://host.test-ctrl.cfahome.com',
    issuer: 'https://cfahome.oktapreview.com/oauth2/auscjsakz3PaAP82K0h7',
    clientId: '0oac8yb7vhKbKhN510h7',
    pkce: false,
  },
  beta: {
    redirectUri: 'https://host.beta.ctrl.cfahome.com',
    clientId: '0oa56wex25aYVEJLb1t7',
    issuer: 'https://cfahome.okta.com/oauth2/aus4i6zex3F52d4rn1t7',
    pkce: false,
  },
  production: {
    redirectUri: 'https://host.ctrl.cfahome.com',
    clientId: '0oa56wex25aYVEJLb1t7',
    issuer: 'https://cfahome.okta.com/oauth2/aus4i6zex3F52d4rn1t7',
    pkce: false,
  },
};

export { oktaEnvSignInConfig, oktaEnvAuthConfig };
